const STORAGE_KEY = 'academia_pending_filiere_subscription_id';

export function getPendingFiliereSubscriptionId() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const id = raw?.trim();
    return id || null;
  } catch {
    return null;
  }
}

export function setPendingFiliereSubscription(filiereId) {
  const id = String(filiereId ?? '').trim();
  if (!id) return;
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch {
    // no-op
  }
}

export function clearPendingFiliereSubscription() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // no-op
  }
}
